// extracted by mini-css-extract-plugin
export default {"rankingInputContainer":"ranking-position-fields_rankingInputContainer__fMGJg"};